import React, { Fragment } from 'react'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'
import Link from 'components/ui/Link/Link'

import messages from './messages'


const AlreadyUpdatedToPayPal = composeDialogModal({
  name: constants.modals.AlreadyUpdatedToPayPal,
  buttonTitle: messages.buttonTitle,
  content: () => (
    <Fragment>
      <FormattedMessage {...messages.text} />
      &nbsp;<Link mailto="support@scentbird.com" />
    </Fragment>
  ),
})

export default AlreadyUpdatedToPayPal
